import Vue from 'vue';
import card from '@/components/ui/Card'

Vue.component('card', card);